import React from "react"

const Heading = ()=>
{
    return <div class="nav"></div>
}

export default Heading;